import Owners from './Owners'

export default Owners
